// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppLogo {
  margin: 0 10px 0 0;
  width: 40px;
}
.mainContainer {
  margin-top: 80px;
}
a.headerMenu {
  color: #fff;
  margin-left: 0.5em;
  text-decoration: none;
}
.drawerListMenu a {
  color: #6b7a8f;
  display: block;
}
.AppLogoHome {
  width: 50%;
}
.sfButtonCont > * {
  margin-left: 10px !important;
  margin-top: 10px !important;
}

.breadcrumbs {
  margin: 0 0 1em 0 !important;
}

.breadcrumbs a {
  text-decoration: none;
  color: #c1c1c1;
}

.breadcrumbs a:not(:first-child):before,
.breadcrumbs span:not(:first-child):before {
  content: ">";
  color: #c1c1c1;
  padding-right: 0.5em;
  margin-left: 0.5em;
}

.show-link {
  text-decoration: none;
  color: #1976d2;
}
@keyframes walk-cycle {
  100% {
    background-position-x: -256px;
  }
}
`, "",{"version":3,"sources":["webpack://./public/assets/css/main.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".AppLogo {\r\n  margin: 0 10px 0 0;\r\n  width: 40px;\r\n}\r\n.mainContainer {\r\n  margin-top: 80px;\r\n}\r\na.headerMenu {\r\n  color: #fff;\r\n  margin-left: 0.5em;\r\n  text-decoration: none;\r\n}\r\n.drawerListMenu a {\r\n  color: #6b7a8f;\r\n  display: block;\r\n}\r\n.AppLogoHome {\r\n  width: 50%;\r\n}\r\n.sfButtonCont > * {\r\n  margin-left: 10px !important;\r\n  margin-top: 10px !important;\r\n}\r\n\r\n.breadcrumbs {\r\n  margin: 0 0 1em 0 !important;\r\n}\r\n\r\n.breadcrumbs a {\r\n  text-decoration: none;\r\n  color: #c1c1c1;\r\n}\r\n\r\n.breadcrumbs a:not(:first-child):before,\r\n.breadcrumbs span:not(:first-child):before {\r\n  content: \">\";\r\n  color: #c1c1c1;\r\n  padding-right: 0.5em;\r\n  margin-left: 0.5em;\r\n}\r\n\r\n.show-link {\r\n  text-decoration: none;\r\n  color: #1976d2;\r\n}\r\n@keyframes walk-cycle {\r\n  100% {\r\n    background-position-x: -256px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
